export default {"src":"/_next/static/media/brandads.58b7e9f3.svg","height":330,"width":472,"blurWidth":0,"blurHeight":0};